import request from "./request";

//门店列表

export function shopList(params) {
  return request({
    method: "POST",
    url: "/Member/shopList",
    data: params,
  });
}

//门店编辑，添加
export function shopSet(params) {
  return request({
    method: "POST",
    url: "/Member/shopSet",
    data: params,
  });
}

//模版下载-门店
export function downloadShop(params) {
  return request({
    method: "POST",
    url: "/Member/downloadShop",
    data: params,
    responseType: "blob",
  });
}

//门店表格导入
export function importShop(params) {
  return request({
    method: "POST",
    url: "/Member/importShop",
    data: params,
  });
}

//开关操作
export function openOperate(params) {
  return request({
    method: "POST",
    url: "/Member/openOperate",
    data: params,
  });
}

//商品列表
export function goodsList(params) {
  return request({
    method: "POST",
    url: "/Member/goodsList",
    data: params,
  });
}

//商品添加，编辑
export function goodsSet(params) {
  return request({
    method: "POST",
    url: "/Member/goodsSet",
    data: params,
  });
}

//商品删除
export function goodsDel(params) {
  return request({
    method: "POST",
    url: "/Member/goodsDel",
    data: params,
  });
}

// 地区-省，市，区

export function getRegion(params) {
  return request({
    method: "POST",
    url: "/index/getRegion2",
    data: params,
  });
}

//权益列表

export function interestsList(params) {
  return request({
    method: "POST",
    url: "/Member/interestsList",
    data: params,
  });
}

//权益添加、编辑

export function interestsSet(params) {
  return request({
    method: "POST",
    url: "/Member/interestsSet",
    data: params,
  });
}

//权益删除

export function interestsDel(params) {
  return request({
    method: "POST",
    url: "/Member/interestsDel",
    data: params,
  });
}

//方案-卡面图片

export function CardImgs(params) {
  return request({
    method: "POST",
    url: "/Member/CardImgs",
    data: params,
  });
}

//方案列表

export function planList(params) {
  return request({
    method: "POST",
    url: "/Member/planList",
    data: params,
  });
}

//方案详情

export function planInfo(params) {
  return request({
    method: "POST",
    url: "/Member/planInfo",
    data: params,
  });
}

//用户会员卡列表

export function userCard(params) {
  return request({
    method: "POST",
    url: "/Member/userCard",
    data: params,
  });
}

//门店下拉

export function shopDrop(params) {
  return request({
    method: "POST",
    url: "/Member/shopDrop",
    data: params,
  });
}

//表格下载-会员卡

export function userTableDownload(params) {
  return request({
    method: "POST",
    url: "/Member/tableDownload2",
    data: params,
    responseType: "blob",
  });
}

//会员卡详情

export function userCardInfo(params) {
  return request({
    method: "POST",
    url: "/Member/userCardInfo",
    data: params,
  });
}
export function writeOffList(params) {
  return request({
    method: "POST",
    url: "/Member/writeList",
    data: params,
  });
}

export function writeOffDownload(params) {
  return request({
    method: "POST",
    url: "/Member/tableDownload3",
    data: params,
    responseType: "blob",
  });
}

export function typeList(params) {
  return request({
    method: "POST",
    url: "/Member/typeList",
    data: params,
  });
}

//方案-添加，编辑
export function planSet(params) {
  return request({
    method: "POST",
    url: "/Member/planSet",
    data: params,
  });
}

//核销类型添加，编辑
export function typeSet(params) {
  return request({
    method: "POST",
    url: "/Member/typeSet",
    data: params,
  });
}

